/**
 * ATDev MutationObserver init
 */
'use strict'

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.addedNodes.length) {
      refStyling();
      deliveryDate();
      insertElement();
      navInsertCollectionLink();
      // hideSearchHomepageElements(); // tmp
      if (window.matchMedia("(min-width: 750px)").matches) {
        productCarousel();
      }
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});